module.exports = __webpack_public_path__ + "img/app_video_poster.2cfa6f3a.jpg";